import React from 'react'
import Header from '../../components/Header'
import Hero from './Hero'
import ContentSection from './ContentSection'
import WhyDriveWithUs from './WhyDriveWithUs'
import Timeline from './Timeline'
import Brands from '../Home/Brands'
import ApplyToDrive from './ApplyToDrive'
import MeetMembers from '../Home/MeetMembers'
import FAQSection from './FAQSection'
import Footer from '../../components/Footer'
import Image from "../../assets/7.svg"

const Drivers = () => {
    return (
        <>
            <Header />

            <Hero />

            <ContentSection />

            <WhyDriveWithUs />

            <section className='flex justify-center items-center px-5'>
                <img src={Image} alt="img" loading='lazy' className='h-auto md:h-[600px]' />
            </section>

            <Timeline />

            <Brands />

            <ApplyToDrive />

            <MeetMembers />

            <FAQSection />

            <Footer />
        </>
    )
}

export default Drivers